import { FC } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { useAppSelector } from '../../hooks/redux';

const PrivateRoute: FC = () => {
  const { userInfo } = useAppSelector(state => state.auth);

  return userInfo ? (
    <Outlet />
  ) : (
    <Navigate
      to="/sign-in"
      replace
    />
  );
};

export default PrivateRoute;
